import { render, staticRenderFns } from "./portion.vue?vue&type=template&id=1d37a04d&scoped=true&lang=html&"
import script from "./portion.vue?vue&type=script&lang=js&"
export * from "./portion.vue?vue&type=script&lang=js&"
import style0 from "./portion.vue?vue&type=style&index=0&id=1d37a04d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d37a04d",
  null
  
)

export default component.exports